<!-- Card Header (optional) -->
@if (headerTemplate) {
  <div class="hc-card__header">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </div>
}

<!-- Card Body -->
<div class="hc-card__body">
  <ng-content></ng-content>
</div>

<!-- Card Footer (optional) -->
@if (footerTemplate) {
  <div class="hc-card__footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
}
